import {
    CaretRightOutlined,
    RightOutlined,
    PrinterOutlined,
    EyeOutlined,
    CheckCircleTwoTone,
} from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Button,
    Form,
    Input,
    Select,
    DatePicker,
    Alert,
    notification,
    Typography,
    Space,
    Spin,
    Card,
    Avatar,
    Descriptions,
    Modal,
    Table,
} from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams, useHref, useLocation } from "react-router-dom";

import memberService from "../../api/member.service";
import ProgrammeCommercialService from "../../api/programme.commercial.service";
import ProgrammeService from "../../api/programme.service";

import timeSlotService from "../../api/time.slot.service";
import clubService from "../../api/clubaffiliation.service";
import tdsSectionService from "../../api/tdssection.service";


import {
    DATE_FORMAT_DMY_SLASH,
    MEMBER_ACCOUNT_ID,
    ROUND_OFF_ACCOUNT_ID,
    SAVE_SUCCESS_MSG,
    SUCCESS_STATUS,
    UPDATE_SUCCESS_MSG,
    BANK_CHARGES_ACCOUNT_ID,
    ADD_ONE_PAYMENT_MODE,
    EDIT_MODE,
    ADD_MODE,
    PAYMENT_SECTION_REQUIRED_MESSAGE,
    TAP_MEMBERSHIP_ADMISSION_CREDIT_ACCOUNT_ID,
    CGST_ID_9_PERCENT,
    SGST_ID_9_PERCENT,
    CLUB_FESS,
    AFFILIATION_FEE_CREDIT_ACCOUNT_ID,
    SERVER_ERROR
} from "../../utility/Constants";

import TimeSlotEnrollment from "../enrollment/TimeSlotEnrollment";
import moment from "moment";
import enrollmentService from "../../api/enrollment.service";
import commonUtility from "../../utility/Utils";
import EnrollmentComponent from "../enrollment/commercial-components/EnrollmentComponent";
import accountService from "../../api/account.service";
import OtherItems from "../enrollment/commercial-components/OtherItems";
import TestFormItem from "../enrollment/commercial-components/TestFormItem";
import PaymentComponent from "../enrollment/commercial-components/PaymentComponent";
import paymentService from "../../api/payment.service";
import StudentCardInfo from "../common/StudentCardInfo";
import { useSelector } from "react-redux";
import ModalWithMessageAndAction from "../common/ModalWithMessageAndAction";
import Paragraph from "antd/lib/skeleton/Paragraph";
import { PRINT_BASE_URL } from "../../utility/URL";

const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;
const { Title } = Typography;

const defaultFormValues = {
    mode: "ADD",
    club_master_id: 0,
    voucher_id: 0,
    cr_ac_id: AFFILIATION_FEE_CREDIT_ACCOUNT_ID,
    student_account_id: MEMBER_ACCOUNT_ID,
    receipt_id: 0,
    receipt_no: "",
    receipt_date: null,
    is_payment_done: "N",
    is_gst_bill: "",
    no_of_months: 0,
    entry_from: "A",
    round_off_amount: 0,
    round_off_account_id: ROUND_OFF_ACCOUNT_ID,
    total_bank_charges: 0,
    bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
    taxable_amount: 0,

    cgst_id: CGST_ID_9_PERCENT,
    cgst_rate: 9,
    cgst_amount: 0,

    sgst_id: SGST_ID_9_PERCENT,
    sgst_rate: 9,
    sgst_amount: 0,
    is_gst_bill: "Y",
    club_gstin: '',
    affiliation_data: [],
    tds_rate_id: undefined,
    tds_rate: 0,
    tds_amount: 0

};

const ClubAffiliationRegistrationView = () => {
    const [form] = Form.useForm();

    const params = useParams();

    let navigate = useNavigate();
    const location = useLocation();
    // const { pathname, search, hash } = location;
    //const href  = useHref();


    const state = useSelector((state) => state.otheritem);


    const [printURL, setPrintURL] = useState("");

    const [receiptID, setReceiptID] = useState(0);
    const [paymentID, setPaymentID] = useState(0);
    const [mode, setMode] = useState(ADD_MODE);



    const [accountList, setAccountList] = useState([]);

    const [isFormChanged, setIsFormChanged] = useState(false);

    const [totalAmount, setTotalAmount] = useState(0);
    const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
    const [totalTaxableAmount, setTotalTaxableAmount] = useState(0);
    const [totalCGSTAmount, setTotalCGSTAmount] = useState(0);
    const [totalSGSTAmount, setTotalSGSTAmount] = useState(0);
    const [totalPayableAmount, setTotalPayableAmount] = useState(0);
    const [totalNetAmount, setTotalNetAmount] = useState(0);
    const [totalRoundOff, setTotalRoundOff] = useState(0);
    const [totalBankCharges, setTotalBankCharges] = useState(0);
    const [totalTdsAmount, setTotalTdsAmount] = useState(0);


    // Payment useState
    const [paymentPaidList, setPaymentPaidList] = useState([]);
    const [totalPaidAmount, setTotalPaidAmount] = useState(0);
    const [remainingAmount, setRemainingAmount] = useState(0);

    const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

    const [openModal, setOpenModal] = useState(false);
    const [responseModalTitle, setResponseModalTitle] = useState("");
    const [responseModalMessage, setResponseModalMessage] = useState("");

    const [clubList, setClubList] = useState([]);
    const [lastPaidUpto, setLastPaidUpto] = useState("");
    const [generatedPaymentYearList, setGeneratedPaymentYearList] = useState([]);
    const [tdsList, setTdsList] = useState([]);



    const columnsPaymentGeneratedInfo = [
        {
            title: 'For Year',
            dataIndex: 'start_year',
            key: 'start_year',
            render: (selectedObj, row) => (
                <Space size="middle">
                    <Text>{`${row.start_year} - ${row.end_year}`}</Text>
                </Space>
            )

        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: (selectedObj, row) => (
                <Space size="middle">
                    {row?.amount?.toFixed(2)}
                </Space>
            )
        },
    ];




    const [cgstList, setCgstList] = useState([]);
    const [sgstList, setSgstList] = useState([]);
    const [igstList, setIgstList] = useState([]);



    /**
         * Get Club List
         */
    useEffect(() => {
        clubService.getClubList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setClubList(res.data.response_data);
            }
        });
    }, []);

    const onClubAffiliationSave = async (values) => {


        console.log("Form Data Values :: ", values);
        // return false;

        if (values.payment_data.length > 0) {
            setPrintURL("");
            setSaveLoaderEnable(true)
            const data = { formdata: values };
            setOpenModal(false);
            setResponseModalTitle("")
            setResponseModalMessage("")

            clubService.saveClubAffiliation(data).then((res) => {
                if (res.data.response_status == SUCCESS_STATUS && res.data.response_data.receipt_master_id > 0) {
                    const resp_data = res.data.response_data;

                    setOpenModal(true)
                    setResponseModalTitle("Success")
                    setResponseModalMessage(`${SAVE_SUCCESS_MSG}`)

                    const print_url = `${PRINT_BASE_URL}taxinvoice/club_affiliation_print/${resp_data.receipt_master_id}/${resp_data.payment_master_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`
                    setPrintURL(print_url);

                    setSaveLoaderEnable(false)
                }
                else {
                    commonUtility.openNotificationWithType("error", "bottomRight", "Error", SERVER_ERROR);
                    setSaveLoaderEnable(false)
                }


            }).then(() => {
                setSaveLoaderEnable(false)
            });
        } else {
            commonUtility.openNotificationWithType("error", "bottomRight", "Error", ADD_ONE_PAYMENT_MODE);
        }



    };

    const onChangeCollapse = (key) => {
        console.log(key);
    };


    const onChangeForYear = async (e, v) => {
        // no_of_year
        // club_master_id
        // generate-payment-year

        setGeneratedPaymentYearList([]);

        // Clear payment list when No Of Year changes so user needs to add payments again
        setPaymentPaidList([]);
        setIsPaymentModeDisabled(false);

        const no_of_year = form.getFieldValue("no_of_years");
        const club_master_id = form.getFieldValue("club_master_id");
        const receipt_id = form.getFieldValue("receipt_id");


        if (parseInt(no_of_year) > 0) {
            const data = {
                formdata: {
                    club_master_id: club_master_id,
                    no_of_years: no_of_year,
                    receipt_id: receipt_id
                },
            };
            await clubService.generateClubPaymentYears(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    if (parseInt(no_of_year) > 0 && res.data.response_data.length > 0) {
                        const taxable_amount = res.data.response_data.reduce((acc, cur) => acc + cur.amount, 0);
                        setTotalTaxableAmount(taxable_amount);

                        const cgst_rate = form.getFieldValue("cgst_rate");
                        const sgst_rate = form.getFieldValue("sgst_rate");
                        const tds_rate_id = form.getFieldValue("tds_rate_id");

                        let tds_rate = 0;
                        if (tds_rate_id && tdsList.length > 0) {
                            const tdsItem = tdsList.find(item => item.tds_id == tds_rate_id);
                            tds_rate = tdsItem ? parseFloat(tdsItem.tds_rate || 0) : 0;
                        }

                        const cgst_amount = cgst_rate > 0 ? (taxable_amount * cgst_rate) / 100 : 0;
                        const sgst_amount = sgst_rate > 0 ? (taxable_amount * sgst_rate) / 100 : 0;

                        let tds_amount = 0;
                        if (tds_rate > 0 && tds_rate_id && tds_rate_id > 0) {
                            tds_amount = (taxable_amount * tds_rate) / 100;
                        }

                        form.setFieldsValue({
                            taxable_amount: parseFloat(taxable_amount).toFixed(2),
                            cgst_amount: cgst_amount,
                            sgst_amount: sgst_amount,
                            tds_rate: tds_rate,
                            tds_amount: tds_amount.toFixed(2),
                        });

                        setTotalTdsAmount(tds_amount.toFixed(2));
                    }
                    else {
                        form.setFieldsValue({
                            taxable_amount: 0,
                            cgst_id: CGST_ID_9_PERCENT,
                            cgst_amount: 0,
                            cgst_rate: 9,
                            sgst_id: SGST_ID_9_PERCENT,
                            sgst_amount: 0,
                            sgst_rate: 9,
                            tds_rate_id: undefined,
                            tds_rate: 0,
                            tds_amount: 0,
                        });
                        setTotalTdsAmount("0.00");
                    }

                    setGeneratedPaymentYearList(res.data.response_data);
                    form.setFieldsValue({
                        affiliation_data: res.data.response_data
                    });
                }
            });
        } else {
            // When No Of Year is 0 or empty, reset all amounts and clear data
            form.setFieldsValue({
                taxable_amount: 0,
                cgst_amount: 0,
                sgst_amount: 0,
                tds_amount: 0,
                total_gst_amount: 0,
                net_amount: 0,
                payable_amount: 0,
                affiliation_data: []
            });

            // Reset all state values
            setTotalTaxableAmount(0);
            setTotalTdsAmount("0.00");
            setTotalCGSTAmount(0);
            setTotalSGSTAmount(0);
            setTotalNetAmount(0);
            setTotalPayableAmount(0);
            setGeneratedPaymentYearList([]);
        }

        calulateGstAndPayable();

    };





    const onSelectTapRegCGST = (e, tag, rate) => {
        if (e) {
            let rateValue = 0;
            if (tag == "DROPDOWN") {
                rateValue = e.rate
            }
            else {
                rateValue = rate
            }

            const taxable = form.getFieldValue("taxable_amount");
            form.setFieldsValue({
                cgst_amount: (taxable * rateValue) / 100,
                cgst_rate: rateValue,
            });
        }
        else {
            form.setFieldsValue({
                cgst_amount: 0,
                cgst_rate: 0,
            });
        }

        calulateGstAndPayable()
    };


    const onSelectTapRegSGST = (e, tag, rate) => {
        if (e) {
            let rateValue = 0;
            if (tag == "DROPDOWN") {
                rateValue = e.rate
            }
            else {
                rateValue = rate
            }

            const taxable = form.getFieldValue("taxable_amount");
            form.setFieldsValue({
                sgst_amount: (taxable * rateValue) / 100,
                sgst_rate: rateValue,
            });
        }
        else {
            form.setFieldsValue({
                sgst_amount: 0,
                sgst_rate: 0,
            });
        }

        calulateGstAndPayable()
    };

    const onSelectTdsRate = (value, option) => {
        console.log("TDS Rate Selected - Value:", value, "Option:", option);

        if (value && option) {
            const tds_rate = parseFloat(option.tds_rate || 0);
            const taxable_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("taxable_amount")) || 0);

            console.log("TDS Calculation - Taxable:", taxable_amount, "Rate:", tds_rate);

            if (taxable_amount > 0 && tds_rate > 0) {
                const tds_amount = (taxable_amount * tds_rate) / 100;
                console.log("Calculated TDS Amount:", tds_amount);

                form.setFieldsValue({
                    tds_rate_id: value,
                    tds_rate: tds_rate,
                    tds_amount: tds_amount.toFixed(2),
                });

                setTotalTdsAmount(tds_amount.toFixed(2));
            } else {
                console.log("Invalid calculation - Taxable:", taxable_amount, "Rate:", tds_rate);
                form.setFieldsValue({
                    tds_rate_id: value,
                    tds_rate: tds_rate,
                    tds_amount: "0.00",
                });
                setTotalTdsAmount("0.00");
            }
        } else {
            console.log("TDS Rate Cleared");
            form.setFieldsValue({
                tds_rate_id: undefined,
                tds_rate: 0,
                tds_amount: 0,
            });
            setTotalTdsAmount("0.00");
        }

        calulateGstAndPayable();
    };

    const calulateGstAndPayable = () => {
        const taxable_amount = commonUtility.sanitizeValue(form.getFieldValue("taxable_amount"));
        const cgst_amount = commonUtility.sanitizeValue(form.getFieldValue("cgst_amount"));
        const sgst_amount = commonUtility.sanitizeValue(form.getFieldValue("sgst_amount"));
        const tds_amount = commonUtility.sanitizeValue(form.getFieldValue("tds_amount"));
        const total_gst = parseFloat(cgst_amount) + parseFloat(sgst_amount);
        const total_payable = parseFloat(taxable_amount) - parseFloat(tds_amount) + parseFloat(cgst_amount) + parseFloat(sgst_amount);
        form.setFieldsValue({
            total_gst_amount: total_gst,
            net_amount: total_payable
        });
        onFormCalculation()
    };





    useEffect(() => {
        const rcpt_dt = commonUtility.dateFormatDDMMYYYY(new Date(), "/");
        form.setFieldsValue({
            receipt_date: rcpt_dt,
        });
    }, []);



    useEffect(() => {
        accountService.accountProfitAndIncomeList().then((res) => {
            setAccountList(res.data.response_data);
        });
    }, []);


    const onSelectClub = (e, value) => {
        setLastPaidUpto("");
        const gstin = e.gstin;
        console.log(gstin);


        form.setFieldsValue({
            taxable_amount: 0,
            cgst_id: CGST_ID_9_PERCENT,
            cgst_amount: 0,
            cgst_rate: 9,
            sgst_id: SGST_ID_9_PERCENT,
            sgst_amount: 0,
            sgst_rate: 9,

        });

        const cgst_rate = form.getFieldValue("cgst_rate");
        onSelectTapRegCGST(e, "OTHER", cgst_rate)

        const sgst_rate = form.getFieldValue("sgst_rate");
        onSelectTapRegSGST(e, "OTHER", sgst_rate)


        //console.log('value',value);

        if (value > 0) {
            const data = {
                formdata: { club_master_id: value, },
            };

            form.setFieldsValue({
                club_master_id: value,
                club_gstin: gstin,
            });

            clubService.getClubLastPaymentDetail(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    const response = res.data.response_data;
                    console.log('response', response);

                    response.length > 0 ? setLastPaidUpto(`${response[0]?.start_year} - ${response[0]?.end_year}`) : setLastPaidUpto("");

                    onChangeForYear(e, value);
                }
            });
        }
    };





    const calculateRate = () => {
        const no_of_month = form.getFieldValue("no_of_years");
        //const rate = form.getFieldValue("rate_per_year");
        const rate = form.getFieldValue("rate_per_year");
        if (parseInt(no_of_month) > 0 && parseFloat(rate) > 0) {
            const taxable_amount = rate * no_of_month;
            form.setFieldsValue({
                taxable_amount: parseFloat(taxable_amount).toFixed(2),
            });
        }
    }

    const onFormCalculation = () => {

        setIsFormChanged(false);

        let total_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("taxable_amount")));
        let total_discount = 0;
        let total_taxable = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("taxable_amount")));
        let total_cgst_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("cgst_amount")));
        let total_sgst_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("sgst_amount")));
        let total_tds_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("tds_amount")));
        let total_payable_amount = parseFloat(commonUtility.sanitizeValue(total_taxable - total_tds_amount)) + parseFloat(commonUtility.sanitizeValue(total_cgst_amount)) + parseFloat(commonUtility.sanitizeValue(total_sgst_amount));

        const payableAmountDetail = commonUtility.getRoundOfAmount(total_payable_amount);
        const new_payable_amount = payableAmountDetail.newPayableAmount;
        const roundoff_amount = payableAmountDetail.roundoffAmount;

        form.setFieldsValue({
            payable_amount: new_payable_amount,
            round_off_amount: roundoff_amount,
        });

        setTotalAmount(total_amount.toFixed(2));
        setTotalDiscountAmount(total_discount.toFixed(2));
        setTotalTaxableAmount(total_taxable.toFixed(2));
        setTotalTdsAmount(total_tds_amount.toFixed(2));
        setTotalCGSTAmount(total_cgst_amount.toFixed(2));
        setTotalSGSTAmount(total_sgst_amount.toFixed(2));
        setTotalNetAmount(total_payable_amount.toFixed(2));
        setTotalPayableAmount(new_payable_amount.toFixed(2));

        setTotalRoundOff(0);
        if (roundoff_amount) {
            setTotalRoundOff(`${roundoff_amount}`);
        }

        setIsFormChanged(true);

    };

    /*
          useEffect(() => {
            onFormCalculation();
          }, [form,state.otheritem]);
          */

    // useEffect(() => {
    // onFormCalculation();
    // }, [isFormChanged]);



    // Payment mode Data
    const [isPaymentModeDisabled, setIsPaymentModeDisabled] = useState(false);
    const addPaymentMode = () => {
        const selected_payment_mode_text = form.getFieldValue("selected_payment_mode_text");
        const mode = form.getFieldValue("selected_payments_mode");
        const paid_amount = form.getFieldValue("paid_amount");
        const dr_account_id = form.getFieldValue("dr_account_id");
        const cheque_no = form.getFieldValue("cheque_no");
        const cheque_date = form.getFieldValue("cheque_date");
        const bank = form.getFieldValue("bank");
        const branch = form.getFieldValue("branch");
        const bank_charges = commonUtility.sanitizeValue(form.getFieldValue('bank_charges'));
        const payment_ref = form.getFieldValue('payment_ref');

        let bank_charges_amount = 0;
        if (commonUtility.sanitizeValue(bank_charges) > 0) {
            bank_charges_amount = (parseFloat(paid_amount) * parseFloat(bank_charges)) / 100;
            bank_charges_amount = Math.round(bank_charges_amount);
        }

        //setIsOtherComponentRender(false)

        if (
            commonUtility.sanitizeObject(selected_payment_mode_text) &&
            commonUtility.sanitizeObject(mode) && commonUtility.sanitizeValue(paid_amount) >= 0
        ) {
            let amount = parseFloat(paid_amount) + parseFloat(bank_charges_amount);
            setPaymentPaidList([
                ...paymentPaidList,
                {
                    rowKey: commonUtility.randomID(),
                    mode_description: selected_payment_mode_text,
                    payment_mode_text: selected_payment_mode_text,
                    payment_mode_id: mode,
                    payment_mode: mode,
                    dr_account_id: dr_account_id,
                    amount: amount,
                    paid_amount: paid_amount,
                    cheque_no: cheque_no,
                    cheque_date: cheque_date,
                    bank_name: bank,
                    bank_branch: branch,
                    bank_charges: bank_charges_amount,
                    payment_ref: payment_ref,
                },
            ]);

            setIsPaymentModeDisabled(true);

            form.setFieldsValue({
                selected_payment_mode_text: "",
                selected_payments_mode: "",
                cheque_no: "",
                cheque_date: "",
                bank: "",
                payment_ref: "",
            });
        }
        else {
            commonUtility.openNotificationWithType("error", "bottomRight", "Error", PAYMENT_SECTION_REQUIRED_MESSAGE);
        }
    };

    // Remove payment Mode
    const removePayment = (index) => {
        const list = [...paymentPaidList];
        list.splice(index, 1);
        setPaymentPaidList(list);

        if (list.length === 0) {
            setIsPaymentModeDisabled(false);
        }
    };

    // useEffect(()=>{

    // },[])


    useEffect(() => {
        setRemainingAmount(
            parseFloat(totalPayableAmount) + parseFloat(totalBankCharges) - parseFloat(totalPaidAmount)
        );
    }, [totalPayableAmount, totalPaidAmount]);


    /***************************************ADD MODE***************************/
    /***************************************ADD MODE***************************/
    /***************************************ADD MODE***************************/
    useEffect(() => {
        //setEnrollmentID(params.enrollmentid);
        setReceiptID(params.receiptid);
        setPaymentID(params.paymentid);
    }, []);

    /*
      useEffect(() => {
        onSelectMember(memberID);
        console.log(memberID);
      }, [programmeID, memberID]);
    
      useEffect(() => {
        const data = {
          formdata: { programme_id: programmeID },
        };
        memberService.memberListByProgramme(data).then((res) => {
          if (res.data.response_status === SUCCESS_STATUS) {
            setMemberList(res.data.response_data);
          }
        });
      }, [programmeID, memberID]);
      */

    /** TAP Additional */

    // useEffect(() => {
    //     memberService.memberListForTapRegistration().then((res) => {
    //         if (res.data.response_status === SUCCESS_STATUS) {
    //             setMemberList(res.data.response_data);
    //         }
    //     });
    // }, [memberID]);

    useEffect(() => {

        form.setFieldsValue({
            rate_per_year: CLUB_FESS,
        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "CGST", usedfor: "O" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setCgstList(res.data.response_data);
            }
        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "SGST", usedfor: "O" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setSgstList(res.data.response_data);
            }
        });
    }, []);




    /** ****************************************************************************
     * ******************************* Edit Mode ***********************************
     * *****************************************************************************
     */


    /**
     * Set Total Payment Amount Data
     */


    useEffect(() => {
        if (receiptID > 0) {
            const data = {
                formdata: {
                    receipt_id: receiptID,
                },
            };


            enrollmentService.JCPReceiptDatabyID(data).then((res4) => {
                if (res4.data.response_status === SUCCESS_STATUS) {
                    const receipt_datam = res4.data.response_data[0];
                    console.log("receipt", receipt_datam);


                    form.setFieldsValue({
                        receipt_id: receipt_datam.receipt_id,
                        no_of_years: receipt_datam.no_of_years,
                        //receipt_date: receipt_data.receipt_date,
                        //receipt_date_input: receipt_data.receipt_date != null && receipt_data.receipt_date != "" ? moment(receipt_data.receipt_date, DATE_FORMAT_DMY_SLASH) : '',
                        club_search: receipt_datam.club_master_id.toString(),
                        club_master_id: receipt_datam.club_master_id,
                        club_gstin: receipt_datam.club_gstin,
                        tds_rate_id: receipt_datam.tds_rate_id || undefined,
                        tds_rate: receipt_datam.tds_rate || 0,
                        tds_amount: receipt_datam.tds_amount || 0,
                        //entry_from: receipt_data.entry_from,
                    });

                    // Set TDS amount state
                    const tdsAmount = receipt_datam.tds_amount || 0;
                    setTotalTdsAmount(tdsAmount.toFixed(2));

                    console.log("TDS Data from JCPReceiptDatabyID:", {
                        tds_rate_id: receipt_datam.tds_rate_id,
                        tds_rate: receipt_datam.tds_rate,
                        tds_amount: receipt_datam.tds_amount
                    });
                }
            });


            clubService.clubYearDataList(data).then((res5) => {
                if (res5.data.response_status === SUCCESS_STATUS) {
                    const affiliation_data = res5.data.response_data;

                    //console.log('affiliation_data',affiliation_data);

                    setGeneratedPaymentYearList(affiliation_data);
                    form.setFieldsValue({
                        affiliation_data: affiliation_data
                    });


                }
            });


            //Receipt Detail Data :

            enrollmentService.componentDetailsAgainstReceiptTap(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {


                    setTotalAmount(0);
                    setTotalDiscountAmount(0);
                    setTotalTaxableAmount(0);
                    setTotalCGSTAmount(0);
                    setTotalSGSTAmount(0);
                    setTotalNetAmount(0);
                    setTotalPayableAmount(0);

                    const receipt_data = res.data.response_data[0];
                    console.log("componentDetailsAgainstReceiptTap Data: ", receipt_data)


                    form.setFieldsValue({
                        mode: "EDIT",
                        // no_of_months: receipt_data.no_of_months,
                        //receipt_id: receipt_data.receipt_master_id,
                        // receipt_no: receipt_data.receipt_no,

                        taxable_amount: receipt_data.taxable_amount,
                        cgst_id: receipt_data.cgst_id,
                        cgst_amount: receipt_data.cgst_amount,
                        cgst_rate: receipt_data.cgst_rate,
                        sgst_id: receipt_data.sgst_id,
                        sgst_amount: receipt_data.sgst_amount,
                        sgst_rate: receipt_data.sgst_rate,
                        total_gst_amount: receipt_data.total_gst_amount,
                        net_amount: receipt_data.net_amount,
                        cr_ac_id: receipt_data.cr_ac_id,
                        //is_waiver: receipt_data.is_waiver,




                    });

                    setTotalAmount(receipt_data.amount.toFixed(2));
                    setTotalTaxableAmount(receipt_data.taxable_amount.toFixed(2));
                    setTotalCGSTAmount(receipt_data.cgst_amount.toFixed(2));
                    setTotalSGSTAmount(receipt_data.sgst_amount.toFixed(2));

                    // Calculate net amount: taxable + CGST + SGST - TDS
                    // Get TDS amount from form as it's set from JCPReceiptDatabyID service
                    const tds_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("tds_amount")) || 0);
                    const total_net_amount =
                        receipt_data.taxable_amount +
                        receipt_data.cgst_amount +
                        receipt_data.sgst_amount -
                        tds_amount;

                    setTotalNetAmount(total_net_amount.toFixed(2));
                    setTotalPayableAmount(total_net_amount.toFixed(2));



                }
            });


            setMode(EDIT_MODE);

        }
    }, [receiptID]);





    /**
     * payment Info && Payment List Detail
     */

    useEffect(() => {
        if (receiptID > 0 && paymentID > 0) {
            const data = {
                formdata: {
                    payment_id: paymentID,
                },
            };
            paymentService.clubPaymentmasterDataByID(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    setTotalPaidAmount(0);
                    setTotalRoundOff(0);

                    const payment_data = res.data.response_data[0];
                    form.setFieldsValue({
                        mode: "EDIT",
                        payment_id: payment_data.payment_id,
                        payment_date: payment_data.payment_date,
                        date_of_payment: payment_data.payment_date
                            ? moment(payment_data.payment_date, DATE_FORMAT_DMY_SLASH)
                            : "",

                        //member_opening_balance: payment_data.short_excess_amount,
                        payment_amount: payment_data.payment_amount,
                        voucher_id: payment_data.voucher_id,
                        // receipt_no: payment_data.payment_no,
                        payable_amount: payment_data.total_payble_amount,
                        //no_of_years: payment_data.no_of_years,
                        //rate_per_year: payment_data.rate_per_year,
                        narration: payment_data.narration,
                        round_off_amount: payment_data.round_off_amount,
                        round_off_account_id: payment_data.round_off_account_id,
                    });

                    setTotalPaidAmount(payment_data.payment_amount.toFixed(2));
                    setTotalRoundOff(payment_data.round_off_amount);
                    setIsPaymentModeDisabled(true);
                }
            });
        }
    }, [paymentID]);



    useEffect(() => {
        if (receiptID > 0 && paymentID > 0) {
            const data = {
                formdata: {
                    payment_id: paymentID,
                },
            };

            paymentService.paymentDetailsDataByID(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    let payment_list = res.data.response_data;
                    const newData = payment_list.map((details) => {
                        return { ...details };
                    });
                    setPaymentPaidList(newData);
                }
            });


        }
    }, [receiptID, paymentID]);

    useEffect(() => {
        const total_paid_amount = paymentPaidList.reduce((a, v) => a = a + parseFloat(v.amount), 0);
        const total_bank_charges = paymentPaidList.reduce((a, v) => a = a + parseFloat(v.bank_charges), 0);

        setTotalBankCharges(parseFloat(commonUtility.sanitizeValue(total_bank_charges)).toFixed(2))
        setTotalPaidAmount(parseFloat(commonUtility.sanitizeValue(total_paid_amount)).toFixed(2))

        form.setFieldsValue({
            payment_amount: total_paid_amount.toFixed(2),
            total_bank_charges: total_bank_charges,
        })

        //  setRemainingAmount(totalPayableAmount -  totalPaidAmount)
    }, [paymentPaidList, receiptID, paymentID]);






    const handleCancel = () => {
        setOpenModal(false);
    };
    function changeLocation(placeToGo) {
        navigate(placeToGo, { replace: true });
        window.location.reload();
    }

    const resetFormFields = () => {
        const defaultFormValues = {
            mode: "ADD",
            enrollment_id: 0,
            member_id: 0,
            programme_id: 0,

            voucher_id: 0,
            date_of_join: null,
            enrollment_start_date: null,
            enrollment_end_date: null,
            cr_ac_id: AFFILIATION_FEE_CREDIT_ACCOUNT_ID,
            student_account_id: MEMBER_ACCOUNT_ID,
            member_opening_balance: 0,
            receipt_id: 0,
            receipt_no: "",
            receipt_date: null,
            is_payment_done: "N",
            no_of_months: 0,
            entry_from: "A",
            round_off_amount: 0,
            round_off_account_id: ROUND_OFF_ACCOUNT_ID,
            total_bank_charges: 0,
            bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
            taxable_amount: 0,

            cgst_id: CGST_ID_9_PERCENT,
            cgst_rate: 9,
            cgst_amount: 0,

            sgst_id: SGST_ID_9_PERCENT,
            sgst_rate: 9,
            sgst_amount: 0,

            is_gst_bill: "Y",
            club_gstin: '',
            affiliation_data: [],
            tds_rate_id: undefined,
            tds_rate: 0,
            tds_amount: 0
        };
    };


    useEffect(() => {
        tdsSectionService.activeList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setTdsList(res.data.response_data);
            } else {
                console.error("Failed to load TDS list:", res.data);
            }
        }).catch((error) => {
            console.error("TDS List API Error:", error);
        });
    }, []);


    return (
        <div className="form-input-style">
            <Row
                className="login-first-step-row"
                style={{ background: "transparent" }}
            >
                <Col
                    className="form-format-type1 enrollment-form tap-registration"
                    xs={24}
                    xl={24}
                >
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onClubAffiliationSave}
                        autoComplete="off"
                        initialValues={defaultFormValues}
                        onFieldsChange={(event) => onFormCalculation()}
                        onKeyUp={(event) => onFormCalculation}
                        onBlur={(event) => onFormCalculation}
                    >
                        <Collapse
                            bordered={false}
                            defaultActiveKey={["programme_jcp", "receipt_jcp"]}
                            onChange={onChangeCollapse}
                            expandIcon={({ isActive }) => (
                                <CaretRightOutlined rotate={isActive ? 90 : 0} />
                            )}
                        >
                            <Panel
                                header={
                                    <>
                                        <h4>Entry</h4>
                                    </>
                                }
                                key="programme_jcp"
                                className="mainPanel"
                            >
                                <Row gutter={20}>
                                    <Col xs={24} xl={12}>
                                        <Row gutter={20}>
                                            <Col className="gutter-row" xs={24} xl={24}>
                                                <Form.Item
                                                    name="club_search"
                                                    label="Search Club"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Select Club",
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        showSearch
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            // option.children.includes(input)
                                                            option.children.toLowerCase().includes(input.toLowerCase())
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                        }
                                                        onSelect={(value, event) =>
                                                            onSelectClub(event, value)
                                                        }
                                                    >
                                                        {clubList.length > 0
                                                            ? clubList.map((club_list) => (
                                                                <Option
                                                                    key={club_list.club_id}
                                                                    value={club_list.club_master_id}
                                                                    gstin={club_list.gstin}
                                                                >
                                                                    {`${club_list.club_name} `}
                                                                </Option>
                                                            ))
                                                            : ""}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="mode" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="club_master_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>

                                                <Form.Item name="voucher_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="entry_from" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="is_gst_bill" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="student_account_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="payment_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="receipt_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="payable_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="affiliation_data" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="round_off_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="round_off_account_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item label="Bank Charge" name="total_bank_charges" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item label="Bank Charge" name="bank_charges_account_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="payment_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                {
                                                    lastPaidUpto && mode == ADD_MODE ? <p style={{ fontWeight: '500' }}>
                                                        Last Paid Upto :  {lastPaidUpto}
                                                    </p> : <></>
                                                }
                                            </Col>



                                            <Col xs={24} xl={12}>
                                                <Form.Item name="no_of_years" label="No Of Year" rules={[
                                                    {
                                                        required: true,
                                                        message: "Enter no of month",
                                                    },
                                                ]}>
                                                    <Input onChange={(event, value) => {
                                                        onChangeForYear(event, value);
                                                    }} />
                                                </Form.Item>
                                            </Col>



                                            {/* <Col xs={24} xl={12}>
                                                <Form.Item name="rate_per_year" label="Rate/Year">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col> */}

                                            <Col xs={24} xl={24}>
                                                {generatedPaymentYearList.length > 0 ? <>
                                                    <div style={{ marginTop: 10, marginBottom: 20 }}>
                                                        <Table key={commonUtility.randomID()} size="small" pagination={false} dataSource={generatedPaymentYearList} columns={columnsPaymentGeneratedInfo} />
                                                    </div>
                                                </> : <></>}

                                            </Col>

                                            <Col xs={24} xl={12} style={{ marginBottom: 10 }}>
                                                {
                                                    generatedPaymentYearList.length > 0 ? <>
                                                        <div><Title level={5}>Total Taxable Amount </Title></div>
                                                    </> : <></>
                                                }
                                            </Col>
                                            <Col xs={24} xl={12} style={{ marginBottom: 10 }}>
                                                <Form.Item name="taxable_amount" label="Total Taxable" hidden={true}>
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                                {
                                                    generatedPaymentYearList.length > 0 ? <><Title level={5} align="right">{totalTaxableAmount}</Title></> : <></>
                                                }
                                            </Col>

                                            <Col xs={24} xl={18}>
                                                <Form.Item name="tds_rate_id" label="TDS Rate">
                                                    <Select
                                                        className="text-left"
                                                        allowClear={true}
                                                        placeholder="Select TDS Rate"
                                                        onSelect={(value, option) => onSelectTdsRate(value, option)}
                                                        onClear={() => onSelectTdsRate(null, null)}
                                                    >
                                                        {tdsList.length > 0
                                                            ? tdsList.map((tds_item) => (
                                                                <Option
                                                                    key={tds_item.tds_id}
                                                                    value={tds_item.tds_id}
                                                                    tds_rate={tds_item.tds_rate}
                                                                >
                                                                    {`${tds_item.tds_desc} - (${tds_item.tds_rate}%)`}
                                                                </Option>
                                                            ))
                                                            : ""}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="tds_rate" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="tds_amount" label="TDS Amount">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="cgst_id" label="CGST">
                                                    <Select className="text-left" allowClear={true} onChange={(value, event) => onSelectTapRegCGST(event, "DROPDOWN", 0)}
                                                        //disabled={savePreviosValueForWave.cgst_disable}
                                                        disabled={true}
                                                    >
                                                        {cgstList.length > 0
                                                            ? cgstList.map((cgst_list) => (
                                                                <Option
                                                                    key={cgst_list.id}
                                                                    value={cgst_list.id}
                                                                    rate={cgst_list.rate}
                                                                >
                                                                    {cgst_list.gstDescription}
                                                                </Option>
                                                            ))
                                                            : ""}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="cgst_rate" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="cgst_amount" label="CGST Amt.">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="sgst_id" label="SGST">
                                                    <Select className="text-left" allowClear={true} onChange={(value, event) => onSelectTapRegSGST(event, "DROPDOWN", 0)}
                                                        //disabled={savePreviosValueForWave.sgst_disable}
                                                        disabled={true}
                                                    >
                                                        {sgstList.length > 0
                                                            ? sgstList.map((sgst_list) => (
                                                                <Option
                                                                    key={sgst_list.id}
                                                                    value={sgst_list.id}
                                                                    rate={sgst_list.rate}
                                                                >
                                                                    {sgst_list.gstDescription}
                                                                </Option>
                                                            ))
                                                            : ""}
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item name="sgst_rate" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="sgst_amount" label="SGST Amt.">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>

                                                <Form.Item name="total_gst_amount" label="Total GST" hidden={true}>
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>

                                                <Form.Item name="net_amount" label="Net Amount" hidden={true}>
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>

                                            </Col>

                                            <Col xs={24} xl={12}>
                                                <Form.Item name="cr_ac_id" label="Account to be Credited" rules={[
                                                    {
                                                        required: true,
                                                        message: 'Account is required',
                                                    },
                                                ]}>
                                                    {/* <Select className="text-left" defaultValue="0"> */}

                                                    <Select
                                                        showSearch
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            // option.children.includes(input)
                                                            option.children.toLowerCase().includes(input.toLowerCase())
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                        }
                                                        placement="bottomLeft"

                                                        allowClear={true}
                                                        disabled={true}

                                                    >
                                                        {
                                                            accountList.length > 0 ?
                                                                accountList.map(account_data => (
                                                                    <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                                ))
                                                                : ''
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={12}>
                                                <Form.Item name="club_gstin" label="GSTIN" >
                                                    <Input readOnly={true} />
                                                </Form.Item>
                                            </Col>



                                        </Row>
                                    </Col>



                                </Row>
                            </Panel>

                            <Panel
                                header={
                                    <>
                                        <h4>Receipt</h4>
                                    </>
                                }
                                key="receipt_jcp"
                                className="mainPanel"
                            >
                                <Collapse defaultActiveKey={["member_payment_panel"]} ghost>
                                    <Panel
                                        header="Receipt"
                                        key="member_payment_panel"
                                        className="member-payment component-panel innerPanel"
                                    >
                                        {/**
                       * Payments Module
                       */}

                                        <PaymentComponent
                                            enrollmentForm={form}
                                            detailInputKey="component_payment"
                                            addPaymentMode={addPaymentMode}
                                            paymentPaidList={paymentPaidList}
                                            removePayment={removePayment}
                                            remainingAmount={remainingAmount}
                                            isPaymentModeDisabled={isPaymentModeDisabled}
                                        />
                                    </Panel>
                                </Collapse>

                                <div className="totalDetails">
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Amount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalAmount} </Text>
                                        </Col>
                                    </Row>
                                    <Row gutter={20} hidden={true}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Discount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalDiscountAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Taxable : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalTaxableAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >+ Total CGST : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalCGSTAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >+ Total SGST : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalSGSTAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >- TDS Amt.{form.getFieldValue("tds_rate") > 0 ? ` (${form.getFieldValue("tds_rate")}%)` : ""} : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalTdsAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Net Amount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalNetAmount} </Text>
                                        </Col>
                                    </Row>

                                    {/* <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic>Total Payable : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalPayableAmount} </Text>
                                        </Col>
                                    </Row> */}


                                    {/* -----Previous Code-------
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Total Payable = Amount to pay + Bank Charges(if any)  :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalPayableAmount} + {totalBankCharges}</Text>
                                        </Col>
                                    </Row> */}


                                    {/* New Changes on 02/04/24 =================Start Here*/}

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Amount to pay :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalPayableAmount}</Text>
                                        </Col>
                                    </Row>
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Bank Charges(if any) :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalBankCharges}</Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Round Off : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalRoundOff} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Total Payable :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{(Number(totalPayableAmount) + Number(totalBankCharges)).toFixed(2)}</Text>
                                        </Col>
                                    </Row>
                                    {/* New Changes on 02/04/24 =================== Ends Here*/}


                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#23910c" }}>Total Paid :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text style={{ fontSize: "18px", color: "#23910c" }}>{totalPaidAmount} </Text>
                                        </Col>
                                    </Row>


                                    <Row gutter={20} hidden={true}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic>Short / Excess Amount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{remainingAmount.toFixed(2)} </Text>
                                        </Col>
                                    </Row>
                                </div>

                                {/* <ModalWithMessageAndAction /> */}

                                <Row justify="end">
                                    <Col>
                                        <Form.Item>
                                            {isSaveLoaderEnable ? (
                                                <Spin />
                                            ) : (
                                                <>
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"
                                                        className="custom-button-green"
                                                    >
                                                        Save <RightOutlined />
                                                    </Button>
                                                </>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>
                    </Form>
                </Col>
            </Row>

            <Modal
                title={responseModalTitle}
                centered
                visible={openModal}
                open={openModal}
                // onCancel={handleCancel}
                closable={false}
                footer={[
                    <a href={printURL} target="_blank" rel="noopener noreferrer">
                        <Button htmlType="button" type="default"><PrinterOutlined /> Print</Button>
                    </a>,

                    <Link to={`/clubaffiliation/club-receipt-list/`} style={{ margin: 1 }}>
                        <Button htmlType="button" type="primary">
                            {" "}
                            <EyeOutlined /> View List
                        </Button>
                    </Link>,

                    <Link
                        to={`/clubaffiliation/entry/`}
                        onClick={() => changeLocation("/clubaffiliation/entry/")}
                        style={{ margin: 1 }}
                    >
                        <Button htmlType="button" type="danger">
                            {" "}
                            <EyeOutlined /> Add More
                        </Button>
                    </Link>,
                ]}
                style={{ width: "100px" }}
                className="responseModal"
            >
                <div style={{ textAlign: "center" }}>
                    <CheckCircleTwoTone
                        twoToneColor="#52c41a"
                        style={{ fontSize: "2.5rem" }}
                    />
                    <h3>{responseModalMessage}</h3>
                </div>
            </Modal>
        </div>
    );
};

export default ClubAffiliationRegistrationView;
